import { render, staticRenderFns } from "./mainPanel.vue?vue&type=template&id=6d896bdb&scoped=true"
import script from "./mainPanel.vue?vue&type=script&lang=js"
export * from "./mainPanel.vue?vue&type=script&lang=js"
import style0 from "./mainPanel.vue?vue&type=style&index=0&id=6d896bdb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d896bdb",
  null
  
)

export default component.exports